import { utm33ToWgs84 } from '../terrain/projections.ts';

/**
 * A UTM-aligned rectangle, densified along each edge and reprojected to WGS84 lng/lat — needed
 * because a straight UTM rectangle is not straight in the map's (web Mercator) projection.
 */
export function densifiedUtmRectangle(
  minX: number,
  minY: number,
  maxX: number,
  maxY: number,
  perSide = 16,
): [number, number][] {
  const pts: [number, number][] = [];
  const addEdge = (x0: number, y0: number, x1: number, y1: number): void => {
    for (let i = 0; i < perSide; i++) {
      const t = i / perSide;
      pts.push([x0 + (x1 - x0) * t, y0 + (y1 - y0) * t]);
    }
  };
  addEdge(minX, maxY, maxX, maxY); // north edge, west -> east
  addEdge(maxX, maxY, maxX, minY); // east edge, north -> south
  addEdge(maxX, minY, minX, minY); // south edge, east -> west
  addEdge(minX, minY, minX, maxY); // west edge, south -> north
  pts.push([minX, maxY]); // close the ring
  return pts.map(([x, y]) => utm33ToWgs84(x, y));
}
